import { AgoraVideoCallProps } from './agora-video-call-props';
import { Album } from './album';
import { Owner } from './owner';

class Vault {
  id: number;

  title: string;

  clipAmount: number;

  createdAt: Date;

  lastUpdate: Date;

  totalTime: number;

  coverThumbnailUrl?: string;

  coverUrl?: string;

  clips?: ClipType[];

  unansweredQuestions?: ClipType[];

  scheduledDowngrade: SubscriptionSchemeId;

  subscriptionStatus: SubscriptionStatus;

  subscriptionType: SubscriptionSchemeId;

  owner: OwnerInfoType;

  contributors: ContributorType[];

  lastPayment: PaymentInfoType | null;

  lastPendingPayment: PaymentInfoType | null;

  nextPaymentDate: Date | null;

  nextPaymentAmount: number;

  videoCallProps?: AgoraVideoCallPropsType;

  qrCodes: QrCode[];

  reminder?: ReminderType | null;

  maxClips: number;

  guests: GuestType[];

  contributorTotal?: number;

  guestTotal?: number;

  albums?: Album[];

  unansweredAlbums?: Album[];

  guestInviteToken?: string;

  // The viewer's role and permissions (owner, editor, contributor, viewer…).
  myAccess?: import('networking/controllers/shares-controller').MyVaultAccess;

  allAlbums?: Album[];

  planKey?: string | null;

  storageKind?: StoragePlanKind | null;

  storageLimit: number;

  aiCredits: number;

  totalStorage: number;

  // The vault's custom order for all its memories, as ids; empty if none.
  memoryOrder?: number[];

  constructor(params?: Vault | null) {
    this.id = params?.id || -1;
    this.title = params?.title || '';
    this.coverThumbnailUrl = params?.coverThumbnailUrl;
    this.coverUrl = params?.coverUrl;
    this.clipAmount = params?.clipAmount || 0;
    this.createdAt = params?.createdAt || new Date();
    this.lastUpdate = params?.lastUpdate || new Date();
    this.totalTime = params?.totalTime || -1;
    this.clips = params?.clips || [];
    this.unansweredQuestions = params?.unansweredQuestions;
    this.scheduledDowngrade =
      params?.scheduledDowngrade === undefined
        ? 'read_only'
        : params?.scheduledDowngrade;
    this.subscriptionStatus =
      params?.subscriptionStatus || 'subscription_active';
    this.subscriptionType = params?.subscriptionType || 'standard';
    this.owner = params?.owner || new Owner();
    this.contributors = params?.contributors || [];
    this.lastPayment = params?.lastPayment || null;
    this.lastPendingPayment = params?.lastPendingPayment || null;
    this.nextPaymentDate = params?.nextPaymentDate || null;
    this.nextPaymentAmount = params?.nextPaymentAmount || 0;
    this.videoCallProps = params?.videoCallProps || new AgoraVideoCallProps();
    this.qrCodes = params?.qrCodes || [];
    this.reminder = params?.reminder || null;
    this.maxClips = params?.maxClips || 0;
    this.guests = params?.guests || [];
    this.contributorTotal = params?.contributorTotal;
    this.guestTotal = params?.guestTotal;
    this.albums = params?.albums;
    this.unansweredAlbums = params?.unansweredAlbums;
    this.guestInviteToken = params?.guestInviteToken;
    this.myAccess = params?.myAccess;
    this.allAlbums = params?.allAlbums;
    this.planKey = params?.planKey ?? null;
    this.storageKind = params?.storageKind ?? null;
    this.storageLimit = params?.storageLimit ?? 0;
    this.aiCredits = params?.aiCredits ?? 0;
    this.totalStorage = params?.totalStorage ?? 0;
    this.memoryOrder = params?.memoryOrder ?? [];
  }
}

export { Vault };
